import { Component, OnInit } from '@angular/core';
import { SpinnerService } from './services/spinner/spinner.service';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  loading: boolean = false;
  title = 'vg-frontend';

  private languageCodes: string[] = ["es"];

  constructor(
    private spinnerService: SpinnerService,
    private translateService: TranslateService) {
  }

  ngOnInit() {
    this.spinnerService.showSpinner$.subscribe(display => {
      this.loading = display;
    });

    this.translateService.addLangs(this.languageCodes);
    this.translateService.setDefaultLang("es");
    this.selectLanguageByCode(this.translateService.getBrowserLang());
  }



  private selectLanguageByCode(languageCode: string): void {
    this.translateService.use(
      this.isLanguageCodeSupported(languageCode)
        ? languageCode
        : this.translateService.getDefaultLang()
    );
  }

  public get currentLanguageCode(): string {
    return this.translateService.currentLang;
  }

  public get supportedLanguageCodes(): string[] {
    return this.languageCodes;
  }

  public onSelectLanguage(e: any): void {
    this.selectLanguageByCode(e.target.value);
  }

  public get todaysDate(): Date {
    return new Date();
  }
  
  private isLanguageCodeSupported(languageCode: string): boolean {
    return this.supportedLanguageCodes.indexOf(languageCode) > -1;
  }
  
}
